import * as Html from "../util/Html.ts";
import * as amplify from "../util/amplify.ts";
import ApiServer from "../ApiServer.ts";
import { type ITaskList, type TaskBean } from "../server/fizapilib.auto.ts";

export {initDom,destroyDom}
Html.registerWidget('widget/minilist',{initDom:initDom,destroyDom:destroyDom})

var node: HTMLElement;
//a taskRefreshed listener: the tasks come with the event
async function display(lists :ITaskList[], listsById :{}, tasks :TaskBean[]){
  const TPL = await import("../widget/minilist.mustache");
  var cloned = [].concat(tasks);
  cloned.sort(function(a,b){
    if(a.complete!==b.complete){
      return a.complete?1:-1;
    }
    return b.creationDate-a.creationDate;
  })
  Html.setHtml(node,TPL,{feed:cloned.slice(0,3)});
}

function initDom(container: HTMLElement){
  node = container;
  if(container.offsetParent !== null) { // Vérifie si l'élément est visible
    ApiServer.loadTaskAndList();
    amplify.subscribe("taskRefreshed",display);
  }
}
function destroyDom(){
  amplify.unsubscribe("taskRefreshed",display);
}
